var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileInformationLightgrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15310_9112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.68 20.7841C5.44498 19.5284 6.52013 18.4905 7.80207 17.7705C9.08402 17.0503 10.5296 16.6721 12 16.6721C13.4704 16.6721 14.916 17.0503 16.1979 17.7705C17.4799 18.4905 18.5549 19.5284 19.32 20.7841M12 14.0984C14.367 14.0984 16.2857 12.1796 16.2857 9.81264C16.2857 7.44571 14.367 5.52693 12 5.52693C9.6331 5.52693 7.71432 7.44571 7.71432 9.81264C7.71432 12.1796 9.6331 14.0984 12 14.0984ZM12 23.5269C18.1541 23.5269 23.1429 18.5382 23.1429 12.3841C23.1429 6.23004 18.1541 1.24121 12 1.24121C5.84601 1.24121 0.857178 6.23004 0.857178 12.3841C0.857178 18.5382 5.84601 23.5269 12 23.5269Z",
    stroke: "#D5D5D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15310_9112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.382812)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInformationLightgrey);
export default __webpack_public_path__ + "static/media/Profile-information-lightgrey.e21b5acf.svg";
export { ForwardRef as ReactComponent };